import React from 'react'
import injectSheet from 'react-jss'
import style from './style'

/**
 * A centered container which contains a form for displaying messages, auth screen, gateway, etc
 */

export const Card = props => {
  const { classes, children, style, className } = props

  return (
    <div className={`${classes.base} ${className}`} style={style}>
      {children}
    </div>
  )
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(Card)
